export default __webpack_public_path__ + "static/media/gallery-wip-greeblies_02.061f42e3.jpg";